export const USER_IS_LOGGED_IN = "user.isLoggedIn";
export const USER_DATA = "user.data";
export const USER_SUITS = "user.suits";
export const SMARTLINKS = "smartlinks";
export const IS_WELCOME_SKIPPED = "welcomeSkip";
